<template>
    <div class="article-box">

        <div class="box white-bg pics-fm">
            <ul class="id-tab">
                <li class="tab-current">个人网站</li>
            </ul>
            <div class="plr20">
                <section>
                    <div class="pic-list-img">
                        <ul>
                            <li><a href="personal/64.html"><i><img src="../../assets/images/pic01.jpg"></i><span>《今夕何夕》Html5响应式个人博客网站模板</span></a>
                            </li>
                            <li><a href="personal/63.html"><i><img src="../../assets/images/pic02.jpg"></i><span>宝宝个人博客模板-亲子博客模板-宝宝个人网站模板</span></a>
                            </li>
                            <li><a href="personal/62.html"><i><img src="../../assets/images/pic03.jpg"></i><span>html5个人博客模板《绅士》</span></a>
                            </li>
                            <li><a href="personal/61.html"><i><img src="../../assets/images/pic04.jpg"></i><span>html5 个人博客模板《蓝色畅想》</span></a>
                            </li>
                            <li><a href="personal/60.html"><i><img src="../../assets/images/pic05.jpg"></i><span>个人博客模板《show time》</span></a>
                            </li>
                            <li><a href="personal/59.html"><i><img src="../../assets/images/pic09.jpg"></i><span>html5古典个人博客模板《青砖屋檐》</span></a>
                            </li>
                            <li><a href="personal/58.html"><i><img src="../../assets/images/pic08.jpg"></i><span>html5个人博客模板《More》</span></a>
                            </li>
                            <li><a href="personal/57.html"><i><img src="../../assets/images/pic07.jpg"></i><span>个人博客模板《早安》</span></a>
                            </li>
                            <li><a href="personal/56.html"><i><img src="../../assets/images/pic06.jpg"></i><span>html5个人博客模板《繁花》</span></a>
                            </li>
                            <li><a href="personal/55.html"><i><img src="../../assets/images/pic07.jpg"></i><span>纯文字个人博客模板《时尚黑》</span></a>
                            </li>
                        </ul>
                    </div>
                    <span class="tab-a-more"><a href="personal/index.html"
                                                title="更多个人网站"><i></i><i></i><i></i></a></span></section>
            </div>
        </div>
        <!-- pics end-->
        <div class="clear blank"></div>
        <div class="box white-bg pics-fm">
            <ul class="id-tab">
                <li class="tab-current">企业网站</li>
            </ul>
            <div class="plr20">
                <section>
                    <div class="pic-list-img">
                        <ul>
                            <li><a href="enterprise/69.html"><i><img src="../../assets/images/pic04.jpg"></i><span>蓝色企业网站模板超实用，完美符合SEO优化，适合企业公司建站的模板</span></a>
                            </li>
                            <li><a href="enterprise/68.html"><i><img
                                    src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/3556363baacfb598d5359c13008f7a00.jpg"></i><span>免费紫色婚庆公司企业网站模板</span></a>
                            </li>
                            <li><a href="enterprise/67.html"><i><img
                                    src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/c29de6913e83ec7e2ae5ad41e221e77b.jpg"></i><span>蓝色集团公司企业网站模板</span></a>
                            </li>
                            <li><a href="enterprise/66.html"><i><img
                                    src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/719aa8704acfb4a3727e6f1c7071441c.jpg"></i><span>门户类型装修公司企业网站模板</span></a>
                            </li>
                            <li><a href="enterprise/65.html"><i><img
                                    src="https://www.yangqq.com/d/file/qiyewangzhanmuban/2019-02-27/c40720abe2562129ec283575b1595541.jpg"></i><span>实用大气的装修公司企业网站模板</span></a>
                            </li>
                        </ul>
                    </div>
                    <span class="tab-a-more"><a href="enterprise/index.html"
                                                title="更多企业网站"><i></i><i></i><i></i></a></span></section>
            </div>
        </div>
        <!-- pics end-->
        <div class="clear blank"></div>
        <div class="box white-bg pics-fm">
            <ul class="id-tab">
                <li class="tab-current">事业单位</li>
            </ul>
            <div class="plr20">
                <section>
                    <div class="pic-list-img">
                        <ul>

                        </ul>
                    </div>
                    <span class="tab-a-more"><a href="unit/index.html" title="更多事业单位"><i></i><i></i><i></i></a></span>
                </section>
            </div>
        </div>
        <!-- pics end-->
        <div class="clear blank"></div>
        <div class="box white-bg pics-fm">
            <ul class="id-tab">
                <li class="tab-current">网购商城</li>
            </ul>
            <div class="plr20">
                <section>
                    <div class="pic-list-img">
                        <ul>

                        </ul>
                    </div>
                    <span class="tab-a-more"><a href="shop/index.html" title="更多网购商城"><i></i><i></i><i></i></a></span>
                </section>
            </div>
        </div>
        <!-- pics end-->
        <div class="clear blank"></div>
    </div>
</template>

<script>
    export default {
        name: "Index"
    }
</script>

<style scoped>

</style>